import { Switch } from "@website/ui/switch";
import { deepOmit } from "@website/utils/deep-omit";
import { isFilled } from "@website/utils/is-filled";
import { SwitchTypes } from "@website/widget/filter/filter.types";
import styles from "@website/widget/filter/index.module.scss";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";

interface SwitchProperties extends SwitchTypes {
  name: string;
}

export const SwitchFilter = ({
  name,
  title,
  description
}: SwitchProperties) => {
  const router = useRouter();
  const { [name]: valueQuery } = router.query as Record<string, string>;
  const value = Boolean(valueQuery);

  function onChange({ target: { checked } }: { target: { checked: boolean } }) {
    router.replace(
      {
        query: deepOmit(
          {
            ...(name === "nearby"
              ? omit(router.query, ["geo_property_summary"])
              : router.query),
            [name]: checked || undefined
          },
          isFilled
        )
      },
      undefined,
      { shallow: true, scroll: false }
    );
  }

  return (
    <div className={styles["switch-filter-container"]}>
      <div className="grid">
        <div id="has-availability">{title}</div>
        <span className={styles["has-availability"]}>{description}</span>
      </div>
      <Switch
        aria-labelledby="has-availability"
        checked={Boolean(value)}
        color="secondary"
        onChange={onChange}
      />
    </div>
  );
};
